
    import { defineComponent } from 'vue';
    import { useI18n } from 'vue-i18n';
    import { IonContent } from '@ionic/vue';
    import AuthService from '../services/auth.service';
    let translate;
    export default  defineComponent({
        name: 'LoginPage',
        components: { IonContent },
        setup() {
            const { t } = useI18n({
                inheritLocale: true,
                useScope: 'global'
            });
            translate = t;
            return { t };
        },
        data() {
            var locale = localStorage.getItem('locale');
            //@ts-ignore
            if (typeof locale == 'undefined' || locale == false || locale == null) {
                locale = 'fr';
            }
            return {
                username: '',
                password: '',
                remember: '0',
                loading: false,
                message: '',
                successful: false,
                hostname: '',
                language: locale,
                languageOptions: [
                    { value: 'en', text: 'English' },
                    { value: 'fr', text: 'Français' },
                ]
            }
        },
        mounted()
        {
            this.hostname = 'http://' + window.location.hostname + ':3000/v1/';
            this.username = localStorage.getItem('username') || "";
            this.remember = this.username == "" ? "0" : "1";
        },
        methods: {
            async OAuth2Microsoft()
            {
                this.loading = true;
                const clientId = "e7d4d6ec-c09e-480b-8c99-83f58e4f6510";
                const redirectUri = document.location.origin + "/auth/callback";
                const consentUrl = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&scope=openid email https://graph.microsoft.com/Group.Read.All profile&state={random_state}&systemName=${document.location.hostname.replace('.app.lexoh.com', '')}`;
                // Get screen dimensions
                const screenWidth = window.screen.width;
                const screenHeight = window.screen.height;
                const width  = 600;
                const height = 600;
                // Calculate position to center the popup
                const left = (screenWidth - width) / 2;
                const top = (screenHeight - height) / 2;
                const ssoWindow = window.open('', "_blank", `width=${width},height=${height},left=${left},top=${top}`);
                if (ssoWindow != null) {
                    ssoWindow.location.href = consentUrl;
                    // Check for redirect completion every second
                    const interval = setInterval(() => {
                        try {
                            console.log(ssoWindow.location.href);
                            if (ssoWindow.location.href.startsWith(redirectUri)) {
                                const urlParams     = new URLSearchParams(ssoWindow.location.search);
                                const code          = urlParams.get('code');
                                const state         = urlParams.get('state ');
                                const session_state = urlParams.get('session_state');
                                // Close the pop-up window
                                ssoWindow.close();
                                clearInterval(interval);
                                console.log(`Microsoft SSO Code: ${code}`);
                                this.handleOAuth2Login(code, 'microsoft', state);
                            }
                        } catch (error) {
                            // Cross-origin error occurs while the popup is still on Microsoft's domain
                            console.log(error);
                        }
                        // Stop checking if the window is closed manually
                        if (ssoWindow.closed) {
                            clearInterval(interval);
                            this.loading = false;
                        }
                    }, 1000);
                } else {
                    console.log('ssoWindow is null');
                    this.loading = false;
                }
            },
            async OAuth2Google() {
                this.loading      = true;
                const clientId    = "379170442916-0kglf532ut2r74p964a4tanl56qehggh.apps.googleusercontent.com";
                const redirectUri = document.location.origin + "/auth/callback";
                const consentUrl  = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&scope=openid email profile&state={random_state}&systemName=${document.location.hostname.replace('.app.lexoh.com', '')}`;
                // Get screen dimensions
                const screenWidth  = window.screen.width;
                const screenHeight = window.screen.height;
                const width        = 600;
                const height       = 600;
                // Calculate position to center the popup
                const left = (screenWidth - width) / 2;
                const top  = (screenHeight - height) / 2;
                const ssoWindow = window.open('', "_blank", `width=${width},height=${height},left=${left},top=${top}`);
                if (ssoWindow != null) {
                    ssoWindow.location.href = consentUrl;
                    // Check for redirect completion every second
                    const interval = setInterval(() => {
                        try {
                            console.log(ssoWindow.location.href);
                            if (ssoWindow.location.href.startsWith(redirectUri)) {
                                const urlParams = new URLSearchParams(ssoWindow.location.search);
                                const code      = urlParams.get('code');
                                const state     = urlParams.get('state');
                                // Close the pop-up window
                                ssoWindow.close();
                                clearInterval(interval);
                                console.log(`Google SSO Code: ${code}`);
                                this.handleOAuth2Login(code, 'google', state);
                            }
                        } catch (error) {
                            // Cross-origin error occurs while the popup is still on Google's domain
                            console.log(error);
                        }
                        // Stop checking if the window is closed manually
                        if (ssoWindow.closed) {
                            clearInterval(interval);
                            this.loading = false;
                        }
                    }, 1000);
                } else {
                    console.log('ssoWindow is null');
                    this.loading = false;
                }
            },
            async handleOAuth2Login(code, provider, state)
            {
                await AuthService.logout(false);
                //@ts-ignore
                this.$store.dispatch('auth/OAuth2', { code, provider, state }).then((result) =>
                {
                    //@ts-ignore
                    this.$store.dispatch('user/get', {}).then((response) =>
                    {
                        //@ts-ignore
                        this.$store.state.auth.user = JSON.parse(localStorage.getItem('user'));
                        if(this.remember == "1") {
                            localStorage.setItem('username', this.username.toLocaleLowerCase());
                        } else {
                            localStorage.setItem('username', "");
                        }
                        this.message = "";
                        this.successful = true;
                    },
                    //@ts-ignore
                    error =>
                    {
                        this.loading = false;
                        this.message = (error.response && error.response.data && error.response.data.errors && error.response.data.errors.message) ? error.response.data.errors.message : error.toString();
                        this.message = translate(this.message);
                    });
                },
                //@ts-ignore
                error =>
                {
                    this.loading = false;
                    this.message = (error.response && error.response.data && error.response.data.errors && error.response.data.errors.message) ? error.response.data.errors.message : error.toString();
                    this.message = translate(this.message);
                });
            },
            async handleLogin()
            {
                this.loading = true;
                //@ts-ignore
                //validate fields...
                var isValid = true;
                if (!isValid)
                {
                    this.loading = false;
                    return;
                }
                if (this.username && this.password)
                {
                    localStorage.setItem('locale', this.language);
                    //@ts-ignore
                    // this.$store.dispatch('auth/register', { username: this.username, password: this.password, email: 'sylvainmartens@gmail.com' }).then(() =>
                    // {
                    // 	console.log('ok');
                    // //@ts-ignore
                    // }, error => {
                    // 	console.log('error');
                    // });
                    await AuthService.logout(false);
                    //@ts-ignore
                    this.$store.dispatch('auth/login', { username: this.username.toLocaleLowerCase(), password: this.password }).then((result) =>
                    {
                        //@ts-ignore
                        this.$store.dispatch('user/get', {}).then((response) =>
                        {
                            //@ts-ignore
                            this.$store.state.auth.user = JSON.parse(localStorage.getItem('user'));
                            if(this.remember == "1") {
                                localStorage.setItem('username', this.username.toLocaleLowerCase());
                            } else {
                                localStorage.setItem('username', "");
                            }
                            this.message = "";
                            this.successful = true;
                            setTimeout(function(){ window.location.href = '/' }, 100);
                        },
                        //@ts-ignore
                        error =>
                        {
                            this.loading = false;
                            this.message = (error.response && error.response.data && error.response.data.errors && error.response.data.errors.message) ? error.response.data.errors.message : error.toString();
                            this.message = translate(this.message);
                        });
                    },
                    //@ts-ignore
                    error =>
                    {
                        this.loading = false;
                        this.message = (error.response && error.response.data && error.response.data.errors && error.response.data.errors.message) ? error.response.data.errors.message : error.toString();
                        this.message = translate(this.message);
                    });
                }
            }
        }
    });
